import {Radio} from '@ui/forms/radio-group/radio';
import {UpsellBillingCycle} from './find-best-price';
import {Trans} from '@ui/i18n/trans';
import {RadioGroup, RadioGroupProps} from '@ui/forms/radio-group/radio-group';
import {UpsellLabel} from './upsell-label';
import {Product} from '../product';
import clsx from 'clsx';
import { CurrencyToggle } from '../currency';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

interface BillingCycleRadioProps extends Omit<RadioGroupProps, 'children'> {
  selectedCycle: UpsellBillingCycle;
  onChange: (value: UpsellBillingCycle) => void;
  products?: Product[];
}


export function BillingCycleRadio({
  selectedCycle,
  onChange,
  products,
  ...radioGroupProps
}: BillingCycleRadioProps) {
  const location = useLocation();
  const isChangePlanRoute = location.pathname === '/billing/change-plan';
  
  // Extract available currencies from products
  const availablePlanCurrencies = useMemo(() => {
    const currencies = new Set<string>();
    products?.forEach(product => {
      product.prices.forEach(price => {
        currencies.add(price.currency);
      });
    });
    return Array.from(currencies);
  }, [products]);
  return (
    <>
    <RadioGroup
  {...radioGroupProps}
  className={clsx(
    'inline-flex rounded-full items-center justify-center overflow-hidden text-sm font-medium bg-primary',
    radioGroupProps.className
  )}
>

      <Radio
        value="month"
        checked={selectedCycle === 'month'}
        onChange={e => e.target.checked && onChange('month')}
        className={clsx(
          'px-6 py-2 transition-colors duration-200 item-center justify-center focus:outline-none',
          'rounded-md',
          selectedCycle === 'month'
            ? 'bg-violet-600 text-white border-black font-bold'
            : 'bg-primary text-black'
        )}
      >
        <span>1 month</span>
      </Radio>
   
      <Radio
        value="year"
        checked={selectedCycle === 'year'}
        onChange={e => e.target.checked && onChange('year')}
        className={clsx(
          'px-6 py-2 transition-colors duration-200 focus:outline-none border-l border-gray-300',
          'rounded-lg',
          selectedCycle === 'year'
            ? 'bg-violet-600 text-white border-black font-bold'
            : 'bg-primary text-black'
        )}
      >
        <span>12 months</span>
        <UpsellLabel products={products} selectedCycle={selectedCycle} />
      </Radio>

      
    </RadioGroup>
    <div className={isChangePlanRoute ? '' : 'my-12 flex justify-center place-items-end'}>
      <CurrencyToggle availableCurrencies={availablePlanCurrencies} />
    </div>
    </>
  );
}